import { Link } from 'react-router-dom'
import { periodToRange } from '../../api/dashboards'
import { leadGenerationReportApi } from '../../api/leadGenerationReport'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { Stat, WidgetBody, formatNum, formatPct } from './WidgetBody'

/** KPI del funnel lead: stesso calcolo del report Lead Generation (il server applica la visibilità). */
export function LeadGenerationKpiWidget({ item }: WidgetProps) {
  const range = periodToRange(item.filters?.period)
  const state = useWidgetData(() => leadGenerationReportApi.report(range), JSON.stringify(range))
  return (
    <WidgetBody state={state}>
      {r => (
        <>
          <div className="md-mini-stats">
            <Stat label="Lead ricevuti" value={formatNum(r.kpi.received)} />
            <Stat label="Contattati" value={formatPct(r.conversionRates.contactRate)} />
            <Stat label="Appuntamenti fatti" value={formatNum(r.stages.appointmentsCompleted)} />
            <Stat label="Attivazioni" value={formatNum(r.stages.activations)} />
          </div>
          <Link to="/reports/lead-generation" className="md-typescale-body-small d-inline-block mt-2">
            Apri il report
          </Link>
        </>
      )}
    </WidgetBody>
  )
}
